import { Home } from '@mui/icons-material'
import moment from 'moment-timezone'
import { useEffect, useState } from 'react'
import { getMessageTimeSheetType } from 'utils'
import { checkOffMorning } from 'utils/common'
import { TimeRecordType } from '../../../types/timeSheet'
import { convertTo24HourFormat } from '../../../utils/dateTime'
import { Bell } from './Bell'
import { FirstIn } from './FirstIn'
import { LastOut } from './LastOut'
import { OTHour } from './OTHour'
import { OutHour } from './OutHour'
import { TotalHour } from './TotalHour'

//type, firstIn, lastOut, notes, overTime, totalWork
type TimeSheetItemProps = {
  arg: TimeRecordType
  event: any
  handleSubmitFormClick: (event: any) => void
}

export const TimeSheetItem = ({ arg, event, handleSubmitFormClick }: TimeSheetItemProps) => {
  const { type, firstIn, lastOut, notes, overTime, totalWork, totalOut, overTimeNotes, date } = arg
  const [isWrongTime, setIsWrongTime] = useState(false)
  const [isOffHalfDay, setIsOffHalfDay] = useState(false)
  const [isToday, setIsToday] = useState(false)
  const [offType, setOffType] = useState('')
  const isMobile = () => window.innerWidth < 768
  if (isMobile()) {
    return (
      <div className="flex flex-col gap-1 w-full items-center justify-center">
        {type === 'Office' || type === 'WFH' ? (
          <>
            {firstIn ? (
              <div className="text-green-500 font-bold">{convertTo24HourFormat(firstIn)}</div>
            ) : (
              <label className="text-red-500 font-bold">-</label>
            )}
            {lastOut ? (
              <div className="text-green-500 font-bold">{convertTo24HourFormat(lastOut)}</div>
            ) : (
              <label className="text-red-500 font-bold">-</label>
            )}
          </>
        ) : null}
      </div>
    )
  }

  const submitClick = () => {
    handleSubmitFormClick(event)
  }

  useEffect(() => {
    if (moment(date).isSame(moment(), 'day')) {
      setIsToday(true)
    }
    const Fdate = new Date(`2024-06-11 ${firstIn}`)
    const Fhours = Fdate.getHours()
    const Fminutes = Fdate.getMinutes()
    const FSeconds = Fdate.getSeconds()
    const Ldate = new Date(`2024-06-11 ${lastOut}`)
    const Lhours = Ldate.getHours()
    const Lminutes = Ldate.getMinutes()

    if (notes.includes('Off_0.5')) {
      if (notes.includes('có lương')) {
        setOffType('Off_P_0.5')
      } else {
        setOffType('Off_U_0.5')
      }
      setIsOffHalfDay(true)
      if (!firstIn) {
        setIsWrongTime(true)
      } else if (!lastOut) {
        setIsWrongTime(true)
      } else {
        if (checkOffMorning(new Date(`2024-06-11 ${firstIn}`), new Date(`2024-06-11 ${lastOut}`))) {
          if (
            Fhours > 13 ||
            (Fhours === 13 && Fminutes > 0) ||
            Lhours < 16 ||
            (Lhours === 16 && Lminutes < 30)
          ) {
            setIsWrongTime(true)
          }
        } else {
          if (Fhours > 8 || (Fhours === 8 && Fminutes > 30) || Lhours < 12) {
            setIsWrongTime(true)
          }
        }
      }
    } else {
      if (type != 'WFH' && type != 'Office' && firstIn && lastOut) {
        if ((Fhours == 12 || Lhours == 12) && totalWork > 4) {
          setIsWrongTime(false)
          return
        }
      }

      if (firstIn) {
        if (
          (Fhours > 8 && Fhours != 12) ||
          (Fhours === 8 && Fminutes > 30) ||
          (Fhours === 8 && Fminutes === 30 && FSeconds > 0)
        ) {
          setIsWrongTime(true)
        }
      } else {
        setIsWrongTime(true)
      }

      if (lastOut) {
        if ((Lhours == 16 && Lminutes <= 30) || Lhours < 16) {
          setIsWrongTime(true)
        }
      } else {
        setIsWrongTime(true)
      }
    }
  }, [])

  return (
    <div className="!border-none mt-0">
      <div className="flex flex-col gap-1 mt-5 items-center">
        {((firstIn || lastOut) && isWrongTime) || isToday ? (
          <>
            <div className="bg-green-500 text-white py-1 px-2 rounded-md text-center font-bold flex gap-2 ">
              <FirstIn
                firstIn={firstIn}
                lastOut={lastOut}
                isHalfDay={isOffHalfDay}
                submitClick={submitClick}
              />
              <div className="text-white font-bold">-</div>
              <LastOut
                firstIn={firstIn}
                lastOut={lastOut}
                isHalfDay={isOffHalfDay}
                submitClick={submitClick}
              />
            </div>
          </>
        ) : (
          <>
            {isOffHalfDay && !isWrongTime ? (
              <>
                {type && (type === 'Office' || type === 'WFH') && (
                  <div className="text-gray-500 py-1 px-2 rounded-md text-center font-bold">
                    {getMessageTimeSheetType(offType)}
                  </div>
                )}
              </>
            ) : null}
          </>
        )}
        {type && type !== 'Office' && type !== 'WFH' && (
          <div className="text-gray-500 py-1 px-2 rounded-md text-center font-bold">
            {getMessageTimeSheetType(type)}
          </div>
        )}
      </div>

      <div className="absolute bottom-[-20px] flex justify-between items-end w-full p-2">
        <div className="p-0 flex flex-row gap-1">
          {!(event.start && [6, 0].includes(event.start.getDay())) && (
            <Bell notes={notes} submitClick={submitClick} />
          )}
          {type === 'WFH' || overTime.toString().toLocaleUpperCase() === 'WFH' ? (
            <>
              <Home className="w-[20px] h-[20px]" color="warning" />
            </>
          ) : null}
          {notes.includes('nữ') ? <span className="text-red-500 font-bold">+</span> : ''}
        </div>
        <div className="flex gap-1">
          {totalOut ? <OutHour totalOut={totalOut} /> : null}
          {overTime ? <OTHour overTime={overTime} overTimeNotes={overTimeNotes} /> : null}
          {totalWork ? (
            <TotalHour
              type={type}
              totalWork={totalWork}
              start_end={`${moment('2024-06-11 ' + firstIn).format('HH:mm:ss') + ' - ' + moment('2024-06-11 ' + lastOut).format('HH:mm:ss')}`}
            />
          ) : null}
        </div>
      </div>
    </div>
  )
}
